export default __webpack_public_path__ + "static/media/Group 158.ea72e022.png";